import {
    Component,
    Inject,
    Input,
    OnInit,
    ViewChild, ElementRef
} from '@angular/core';
import {UploadEvent, FileSystemFileEntry} from 'ngx-file-drop';
import {ProjectManagementService} from "../../services/project-management.service";
import {DOCUMENT} from "@angular/platform-browser";
import {LogService} from "../../services/log.service";
import {NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {DataService} from "../../services/data.service";

declare let tinymce: any;

@Component({
    selector: 'app-create-wall-post',
    templateUrl: './create-wall-post.component.html',
    styleUrls: ['./create-wall-post.component.scss', '../project-wall/project-wall.component.scss']
})

export class CreateWallPostComponent implements OnInit {

    @Input() isParent = false;
    @Input() indexNo = "";
    @ViewChild('fileInput') fileInput: ElementRef;

    files = [];
    public projectId = 0;
    wallPostId = null;
    wallReplyId = null;
    public modalRef: NgbModalRef;
    loading = false;
    fileSizeError = false;
    requiredError = false;

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private project_management_service: ProjectManagementService,
        private logService: LogService,
        private data_service: DataService,
    ) { }

    ngOnInit() {
        if(this.projectId === 0) {
            this.projectId = this.data_service.selected_project;
        }
    }

    get_local_draft_path() {
        let str = "wall_draft_this_" + this.projectId;
        if (this.wallPostId) {
            str += "_" + this.wallPostId;
        }
        if (this.wallReplyId) {
            str += "_" + this.wallReplyId;
        }
        return str;
    }

    get_local_draft(path) {
        return JSON.parse(localStorage.getItem(path));
    }

    set_local_draft(path, data) {
        if (data.trim() === '' ) {
            localStorage.removeItem(path);
        } else {
            const selected_project = this.data_service.get_array_details(
                this.data_service.project_list,
                "fip_id",
                this.data_service.selected_project
            );

            localStorage.setItem(this.get_local_draft_path(), JSON.stringify({
                "fip": selected_project.fip,
                "title": selected_project.title,
                "contents": data,
                "indexNo": this.indexNo
            }));
        }
    }

    /**
     * Key handler for tiny mce editor
     * @param status - true for init, false for destroy
     */
    editor_status(status) {
        if (status) {
            if(localStorage.getItem(this.get_local_draft_path())) {
                tinymce.activeEditor.setContent(
                    this.get_local_draft(
                        this.get_local_draft_path()
                    )['contents']
                );
            }
        }
    }

    keyupHandlerFunction(event) {
        this.set_local_draft(
            this.get_local_draft_path(),
            event
        );
    }

    /**
     * Handle dropped files
     * @param {UploadEvent} event
     */
    public dropped(event: UploadEvent) {
        for (const file of event.files) {
            const fileEntry = file.fileEntry as FileSystemFileEntry;
            fileEntry.file(info => {
                this.files.push(info);
                this.logService.printLog(info);
            });
        }
    }

    fileUpload(buttonFiles) {
        for (const buttonFile of buttonFiles) {
            this.files.push(buttonFile);
        }
        if(this.files.length > 0) {
            this.requiredError = false;
        }
    }

    wall_post() {
        const wall_data = {};
        wall_data["attached_file"] = this.files;
        wall_data['wall_message'] = tinymce.activeEditor.getContent();
        this.loading = true;
        this.fileSizeError = false;

        // check wall content
        if(wall_data['wall_message'].trim() === '' && wall_data['attached_file'].length === 0) {
            this.requiredError = true;
        } else {
            this.requiredError = false;
        }

        // check file size < 100MB
        // we will have to modify the backend also
        for(const i in wall_data['attached_file']) {
            if(wall_data['attached_file'][i].size / 1024 / 1024 > 100) {
                this.fileSizeError = true;
            }
        }

        if(!this.requiredError && !this.fileSizeError) {
            this.project_management_service.wall_post(this.projectId, wall_data, (resp) => {
                this.loading = false;

                this.logService.printLog("Got Project Details in create wall post controller callback");
                // this.new_wall = {};
                this.files = [];
                this.fileInput.nativeElement.value = "";

                tinymce.activeEditor.setContent('');
                this.set_local_draft(this.get_local_draft_path(), '');

                // Insert wall post in the wall list if parent reply
                if (this.isParent) {
                    this.data_service.wall_list.unshift(resp.data);
                } else {
                    this.logService.printLog("Wall data", wall_data);
                }

                if(this.modalRef) {
                    this.modalRef.close(resp.data);
                }
            }, this.wallPostId, this.wallReplyId);
        } else {
            this.loading = false;
        }
    }

    removeFile(index) {
        this.files.splice(index, 1);
        this.fileInput.nativeElement.value = "";
    }
}
